export default "__VITE_ASSET__CpcDFerL__"